export enum Tab {
  Chat,
  Search,
}

export enum Sender {
  User = "User",
  Nemo = "Nemo",
}
